import SpadeIcon from '@/assets/icons/spade-suit.svg?react';
import { MyProfileCard } from '@/features/profile/components/myProfileCard';
import {
  SubscriptionDialogBody,
  SubscriptionDialogContent,
  SubscriptionDialogDescription,
  SubscriptionDialogFooter,
  SubscriptionDialogHeader,
  SubscriptionDialogHeading,
  SubscriptionDialogTitle,
} from '@/features/subscription/components/subscriptionDialog';
import { Button } from '@/shared/components/ui/button';

export interface SubscriptionSuccessPageProps {
  onClose: () => void;
}

export function SubscriptionSuccessPage({
  onClose,
}: SubscriptionSuccessPageProps) {
  return (
    <SubscriptionDialogContent className="md:p-0">
      <SubscriptionDialogBody>
        <SubscriptionDialogHeader>
          <SubscriptionDialogHeading>
            <SubscriptionDialogTitle>
              You're an <span className="text-yellow-400">Ace!</span>
            </SubscriptionDialogTitle>
            <SubscriptionDialogDescription>
              Top of the pack. Unlimited powers.
            </SubscriptionDialogDescription>
          </SubscriptionDialogHeading>
        </SubscriptionDialogHeader>

        <MyProfileCard />

        <p className="text-cold-300 text-center text-sm">
          Changes will take effect shortly
        </p>
      </SubscriptionDialogBody>

      <SubscriptionDialogFooter>
        <Button
          variant="destructive"
          size="lg"
          className="w-full"
          onClick={onClose}
        >
          <SpadeIcon className="size-4 text-black" />
          Let's go!
        </Button>
      </SubscriptionDialogFooter>
    </SubscriptionDialogContent>
  );
}
